<template>
  <SettingsSection>
    <SettingsSectionTitle> Merchant </SettingsSectionTitle>
    <SettingsSubsection title="Address">
      <SettingsAddressForm />
    </SettingsSubsection>
  </SettingsSection>
</template>
